/**
 * @Author : ShaJiaJing
 * @Date : 2019/6/4
 * @Version : 1.0
 * @Content : 仪表盘配置
 */
export default {
  common: {
    details: '查看详情',
    expireDate: '到期时间',
    robot: '机器人',
    status: '状态',
    today: '今天',
    yesterday: '昨天',
    lastWeek: '上周',
    lastThirty: '过去30天'
  },
  quantifier: {
    day: '天'
  },
  first: {
    title: '@:dashboard.common.robot运行实况',
    detail: {
      title: '@:dashboard.common.robot详情',
      robot: '@:dashboard.common.robot：',
      process: '流程：',
      currentState: '当前状态：',
      startTime: '开始时间：',
      endTime: '结束时间：'
    },
    recentTask: {
      title: '最近执行的任务'
    }
  },
  second: {
    title: '设计器状态',
    remainDays: '剩余{day}天',
    expireDate: '@:dashboard.common.expireDate：'
  },
  third: {
    title: '机器人状态',
    name: '机器人名称',
    days: '剩余天数',
    status: '状态',
    expireDate: '@:dashboard.common.expireDate'
  },
  fourth: {
    title1: '机器人工作状态',
    title2: '系统可用流程',
    title3: '过去24小时完成任务',
    title4: '过去24小时失败任务',
    nums: '{n}个',
    normal: '@:dashboard.fourth.nums正常',
    using: '@:dashboard.fourth.nums启用',
    fault: '@:dashboard.fourth.nums故障',
    timeout: '@:dashboard.fourth.nums超时',
    error: '@:dashboard.fourth.nums异常',
    stopped: '@:dashboard.fourth.nums中断'
  },
  fifth: {
    title: '任务时间趋势'
  },
  sixth: {
    title: '失败趋势'
  }
}
